export const LITERACY_EVENT_POINT_PING_LOCATION = {
	// show the point pings above the point count
	location: { x: '80%', y: '90%' },
}
